class InstructionViewEvent {
    sessionId: string;
    duration: number;

    static from(obj) {
        return Object.assign(new InstructionViewEvent(), obj);
    }
}

export { InstructionViewEvent };
